export default __webpack_public_path__ + "static/TitilliumWeb-Bold-1fc8e38ce6e1562e71843c4d52c95a9d.woff";